import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Callout } from '@node-space/storybook-components/dist/Callout'
import { TextAction } from '@node-space/storybook-components/dist/TextAction'
import { Box } from '@node-space/ui-components'

export interface FormGetErrorProps {
  introduction?: string
}

export const FormGetError = ({ introduction }: FormGetErrorProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const handleLogIn = () => navigate('/login')

  return (
    <Box paddingT={24} name="get error callout">
      <Callout state="error" showCloseButton={false}>
        {introduction ?? t('requestErrors.getErrorIntro')}
        {` ${t('requestErrors.pleaseTryTo')} `}
        <TextAction text={t('requestErrors.refreshPage')} inheritColor isWindowReload />
        {` ${t('requestErrors.or')} `}
        <TextAction text={t('requestErrors.logIn')} inheritColor onClick={handleLogIn} />.
      </Callout>
    </Box>
  )
}
